import { Injectable } from '@angular/core';

import { ApiService } from '../api/api.service';

import { Collector } from '../models/collector.model';
@Injectable({
  providedIn: 'root'
})
export class CollectorService {

  constructor(private api: ApiService) { }

  getCollectors(filterData: any = {}, page = 1, limit = 10) {
    const filter = Object.assign({}, filterData);
    delete filter.country;  
    return this.api.collector.getAll()
      .filter(filter)
      .page(page)
      .per_page(limit)
      .promise()
      .then(c => c)
      .catch(err => {
        throw err;
      });
  }

  updateCollector(collector: Collector) {
    return this.api.collector.put(collector).promise()
      .then(c => {
        const collector = new Collector();
        const { id,
          sponsor_id,
          fronting_id,
          name,
          merchant_code,
          sponsor,
          fronting,
          status,
          days,
          country_id,
          collector_type,
          file_generation_path,
          schedule_config
        } = c.data;
        collector.id = id;
        collector.sponsor_id = sponsor_id;
        collector.fronting_id = fronting_id;
        collector.name = name;
        collector.merchant_code = merchant_code;
        collector.sponsor = sponsor;
        collector.fronting = fronting;
        collector.status = status;
        collector.days = days;
        collector.country_id = country_id;
        collector.collector_type = collector_type;
        collector.file_generation_path = file_generation_path;
        collector.schedule_config = schedule_config;
        return collector;
      })
      .catch(err => {
        console.error('Error updating collector:', err);
        throw err;
      });
  }

  createCollector(collector: Collector) {
    return this.api.collector.post(collector).promise()
      .then(c => {
        const collector = new Collector();
        const { id,
          sponsor_id,
          fronting_id,
          name,
          merchant_code,
          sponsor,
          fronting,
          status,
          days,
          country_id,
          collector_type,
          file_generation_path,
          schedule_config
        } = c.data;
        collector.id = id;
        collector.sponsor_id = sponsor_id;
        collector.fronting_id = fronting_id;
        collector.name = name;
        collector.merchant_code = merchant_code;
        collector.sponsor = sponsor;
        collector.fronting = fronting;
        collector.status = status;
        collector.days = days;
        collector.country_id = country_id;
        collector.collector_type = collector_type;
        collector.file_generation_path = file_generation_path;
        collector.schedule_config = schedule_config;
        return collector;
      })
      .catch(err => {
        console.error('Error creating collector:', err);
        throw err;
      });
  }

  deleteCollector(collectorId: string) {
    return this.api.collector.delete(collectorId).promise()
      .then(c => c.data)
      .catch(err => {
        console.error('Error deleting collector:', err);
        throw err;
      });
  }

  getCollectorByCriteria(criteria: any): Promise<Collector[]> {
    return this.api.collector.getByCriteria(criteria)
      .promise()
      .then(c => {
        if (c.data.length === 0) {
          return [];
        }

        return c.data.map(
          ({ id,
            sponsor_id,
            fronting_id,
            name,
            merchant_code,
            days,
            country_id,
            collector_type,
            file_generation_path,
            schedule_config
          }) => {
            const collector = new Collector();
            collector.id = id;
            collector.sponsor_id = sponsor_id;
            collector.fronting_id = fronting_id;
            collector.name = name;
            collector.merchant_code = merchant_code;
            collector.days = days;
            collector.country_id = country_id;
            collector.collector_type = collector_type;
            collector.file_generation_path = file_generation_path;
            collector.schedule_config = schedule_config;
            return collector;
          });
      })
      .catch(err => { 
        throw err;
      });
  }

  getCollectorByProductId(productId) {
    if (!productId) {
      return Promise.resolve([]);
    }

    return this.api.collector.getCollectorByProductId(productId)
      .promise()
      .then(c => {
        if (c.data.length === 0) {
          return [];
        }

        return c.data.map(
          ({ id,
            sponsor_id,
            fronting_id,
            name,
            merchant_code,
            days,
            country_id,
            collector_type,
            file_generation_path,
            schedule_config
          }) => {
            const collector = new Collector();
            collector.id = id;
            collector.sponsor_id = sponsor_id;
            collector.fronting_id = fronting_id;
            collector.name = name;
            collector.merchant_code = merchant_code;
            collector.days = days;
            collector.country_id = country_id;
            collector.collector_type = collector_type;
            collector.file_generation_path = file_generation_path;
            collector.schedule_config = schedule_config;
            return collector;
          });
      })
      .catch(err => { 
        throw err;
      });
  }
}
